import HeroSection from '../components/Overview/HeroSection';
import VeterinaryFacilitiesSection from '../components/Overview/VeterinaryFacilitiesSection';
import NigeriaLivestockOverview from '../components/Overview/NigeriaLivestockOverview';
import MarketPricesSection from '../components/Overview/MarketPricesSection';
import ProcessingFacilitiesSection from '../components/Overview/ProcessingFacilitiesSection';

export default function Overview() {
  return (
    <>
      <HeroSection />
      <MarketPricesSection />
      <ProcessingFacilitiesSection />
      <VeterinaryFacilitiesSection />
      <NigeriaLivestockOverview />
    </>
  );
}
